var path = 'app/core/views/alert-smallResolution.html';
var html = "<div class=\"alert alert-danger alert-smallResolution\">\n  <h1>{{\"message.warning\"|i8n}}</h1>\n  <h4>{{\"message.smallScreenResolution\"|i8n}}</h4>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;